
import { useState, useEffect } from 'react';
import legalRepresentativeServices from '../api/legalRepresentativeServices';

export const useAccountRepresentatives = (accountId) => {
  const [data, setData] = useState({
    representatives: [],
    pagination: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    search: '',
    status: null,
    mandateType: null,
    sortBy: 'CreationDate',
    sortDescending: true,
    pageNumber: 1,
    pageSize: 20
  });

  const fetchRepresentatives = async (currentFilters) => {
    if (!accountId) {
      setError('ID du compte manquant');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await legalRepresentativeServices.getAccountRepresentatives(
        accountId, 
        currentFilters
      );

      if (result.success) {
        setData({
          representatives: result.data,
          pagination: result.pagination
        });
      } else {
        setError(result.message || 'Erreur lors du chargement des données');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepresentatives(filters);
  }, [accountId, filters]);

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters, pageNumber: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({ ...prev, pageNumber: newPage }));
  };


  const resetFilters = () => {
    setFilters({
      search: '',
      status: null,
      mandateType: null,
      sortBy: 'CreationDate',
      sortDescending: true,
      pageNumber: 1,
      pageSize: 20
    });
  };

  return {
    representatives: data.representatives,
    pagination: data.pagination,
    loading,
    error,
    filters,
    updateFilters,
    handlePageChange,
    resetFilters,
    refetch: () => fetchRepresentatives(filters)
  };
};